module.exports = __webpack_public_path__ + "img/gallery_1.2e3a7e90.jpg";